// Dota 2 game config — values mirror what is currently hardcoded in
// components/DraftBoard.js; Phase 2 of the unify plan switches DraftBoard
// to read from here instead.

import heroIdMap from './heroIdMap';

const dota = {
  id: 'dota',
  name: 'Dota 2',

  // Capability flags. GSI = Valve's Game State Integration; only Dota has it,
  // so live pick timers are only possible here. Maps are an MLBB-only concept.
  features: {
    gsi: true,
    maps: false,
    everyonePremium: false,
  },

  // Captains Mode board positions (1–24, chronological pick/ban order).
  // Mirrors the inline arrays in DraftBoard.js (radiant/dire bans & picks).
  board: {
    positionCount: 24,
    radiantBans: [1, 2, 5, 10, 11, 19, 21],
    radiantPicks: [8, 14, 15, 18, 23],
    direBans: [3, 4, 6, 7, 12, 20, 22],
    direPicks: [9, 13, 16, 17, 24],
    // Sequence numbers rendered as large boxes (DraftState.getLargeBoxSequences)
    largeBoxSequences: ['8', '9', '13', '14', '15', '16', '17', '18', '23', '24'],
  },

  teams: { a: 'Radiant', b: 'Dire' },

  heroes: {
    idMap: heroIdMap,
    imageCdn: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/',
    defaultImage: 'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota_react/heroes/default.png',
    // Local copies (public/heroes/, via scripts/download-hero-images.js) so canvas
    // export isn't tainted by Steam's cross-origin CDN. CDN URL is the fallback.
    localImagePath: '/heroes/',
    idSource: 'https://api.opendota.com/api/heroes',
  },

  firebaseProjectId: 'draftsimulatorapp',

  // Web app credentials for src/firebase/config.js (moved from its hardcoded block)
  firebase: {
    apiKey: "AIzaSyCzm-XQZSx8CWzQ8a8d_FUHJyLxGeTntYw",
    authDomain: "draftsimulatorapp.firebaseapp.com",
    projectId: "draftsimulatorapp",
    storageBucket: "draftsimulatorapp.appspot.com",
    messagingSenderId: "1043835478071",
    appId: "1:1043835478071:web:be5bee89f19496a2205fb2",
    measurementId: "G-506N49ENV7"
  },
};

export default dota;
